export default __webpack_public_path__ + "static/media/pp_default.d7e2bff0.jpg";